const types = {
  OPEN_FORM_MODAL: "OPEN_FORM_MODAL",

  CLOSE_FORM_MODAL: "CLOSE_FORM_MODAL",
};

export default types;
